import { colors, type ColorValue } from '@frontend/constants';
import type { CommonSVGProps } from './helpers';

export const AwaitingMemberResponseTaskBadge = ({
  backgroundColor = '#FBBF24' as ColorValue,
  fill = colors.yellow['950'],
  stroke = colors.trueWhite,
  ...props
}: CommonSVGProps & { backgroundColor?: ColorValue }) => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <rect fill={backgroundColor} height="15" rx="7.5" width="15" x="0.5" y="0.5" />
    <rect height="15" rx="7.5" stroke={stroke} width="15" x="0.5" y="0.5" />
    <path
      d="M5.33594 5.6672C5.33594 5.62288 5.34479 5.579 5.36196 5.53813C5.37913 5.49726 5.40428 5.46023 5.43594 5.4292C5.79922 5.07308 6.28455 4.86878 6.79316 4.85788C7.30176 4.84698 7.7954 5.03031 8.1736 5.37054L8.2906 5.47987C8.53375 5.6929 8.846 5.81035 9.16927 5.81035C9.49254 5.81035 9.80479 5.6929 10.0479 5.47987L10.1309 5.4042C10.3343 5.2432 10.6399 5.37187 10.6676 5.62954L10.6693 5.6672V8.6672C10.6693 8.71153 10.6604 8.75541 10.6432 8.79628C10.6261 8.83714 10.6009 8.87417 10.5693 8.9052C10.206 9.26132 9.72065 9.46563 9.21205 9.47653C8.70345 9.48742 8.20981 9.3041 7.8316 8.96387L7.7146 8.85454C7.47912 8.6482 7.17853 8.53132 6.86551 8.52438C6.55249 8.51743 6.24702 8.62086 6.0026 8.81654V11.0005C6.00251 11.0855 5.96998 11.1672 5.91165 11.229C5.85333 11.2908 5.77362 11.3279 5.68881 11.3329C5.60399 11.3379 5.52048 11.3103 5.45533 11.2558C5.39018 11.2013 5.34831 11.1239 5.33827 11.0395L5.33594 11.0005V5.6672Z"
      fill={fill}
    />
  </svg>
);
